import type { IconSvgObject } from './types';

const LocateFixedIcon: IconSvgObject = [
  ["circle", { cx: "11.9961", cy: "12", r: "7", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "11.9961", cy: "12", r: "3", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18.9961 12H21.9961", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M1.99609 12H4.99609", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M11.9961 19L11.9961 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M12 2L12 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "5" }]
];

export default LocateFixedIcon;
